// export function handleMenuMobile() {
//   const btnMenu = document.querySelector("#btn-menu");
//   const iconClose = document.querySelector("#icon-close");
//   const iconOpen = document.querySelector("#icon-open");
//   const menu = document.querySelector("#menu-main-menu");
//   const menuContainer = document.querySelector(".menu-container");
//   const subMenuList = document.querySelectorAll(".menu-item-has-children");
//   const html = document.documentElement;

//   function handleClickMenu(event) {
//     event.preventDefault();

//     menu.classList.toggle("active");
//     iconOpen.classList.add("hidden");
//     iconClose.classList.remove("hidden");

//     outsideClick(menu, () => {
//       menu.classList.remove("active");
//       iconOpen.classList.remove("hidden");
//       iconClose.classList.add("hidden");
//     });
//   }

//   function handleClickSubMenu() {
//     const submenu = this.querySelector(".sub-menu");
//     submenu.classList.add("active");

//     outsideClick(this, () => {
//       submenu.classList.remove("active");
//     });
//   }

//   function outsideClick(element, callback) {
//     const outside = "data-outside";

//     if (!element.hasAttribute(outside)) {
//       setTimeout(() => {
//         html.addEventListener("click", handleOutsideClick);
//       });

//       element.setAttribute(outside, "");
//     }

//     function handleOutsideClick(event) {
//       const elementId = element.id;

//       if (!element.contains(event.target)) {
//         element.removeAttribute(outside);

//         html.removeEventListener("click", handleOutsideClick);

//         callback();
//       }
//     }
//   }

//   btnMenu.addEventListener("click", handleClickMenu);

//   if (subMenuList) {
//     subMenuList.forEach((menu) => {
//       menu.addEventListener("click", handleClickSubMenu);
//     });
//   }
// }

export function handleMenu() {
  const menuMobile = document.getElementById("site-navigation");
  const menuButton = document.getElementById("btn-menu");
  const menuBgDark = document.getElementById("bg-menu-dark");
  const menuOpen = document.getElementById("icon-open");
  const menuClose = document.getElementById("icon-close");

  menuButton.addEventListener("click", () => {
    menuMobile.classList.toggle("hidden");
    menuMobile.classList.toggle("block");

    menuBgDark.classList.toggle("hidden");
    menuBgDark.classList.toggle("block");
  });

  // Quando clicar no background
  menuBgDark.addEventListener("click", () => {
    menuMobile.classList.add("hidden");
    menuMobile.classList.remove("block");
    menuBgDark.classList.add("hidden");
  });
}
